import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface ThemeState{
  theme: 'default' | 'light' | 'dark';
}

const initialState: ThemeState = {
  theme: 'default',
}

export const themeSlice = createSlice({
  name: 'themeSlice',
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<'default' | 'light' | 'dark'>) => {
      state.theme = action.payload;
    }
  }
})

export const { setTheme } = themeSlice.actions;

export const themeReducer = themeSlice.reducer;

export const selectTheme = (state: RootState) => state.theme;
